import {
  UpdateGuttagekontoMutation,
  UpdateGuttagekontoMutationVariables,
} from '@/gql/graphql';
import { gql, TypedDocumentNode } from '@apollo/client';

export const UPDATE_GUTTAGEKONTO: TypedDocumentNode<
  UpdateGuttagekontoMutation,
  UpdateGuttagekontoMutationVariables
> = gql`
  mutation UpdateGuttagekonto(
    $idMitarbeiter: String!
    $jahr: Int!
    $uebertragAusVorjahr: Float!
  ) {
    mitarbeiter_updateGuttagekonto(
      input: {
        idMitarbeiter: $idMitarbeiter
        jahr: $jahr
        uebertragAusVorjahr: $uebertragAusVorjahr
      }
    ) {
      result {
        ausgezahlteGuttage
        gegebeneGuttage
        genommeneGuttage
        istStand
        jahr
        uebertragAusVorjahr
      }
      error {
        message
      }
    }
  }
`;
